var exports = {
  "kL": "xf0b3b88a--c07039--container",
  "fB": "xf0b3b88a--c07039--user-info",
  "Jm": "xf0b3b88a--c07039--user-info--active",
  "uV": "xf0b3b88a--c07039--delimiter",
  "UL": "xf0b3b88a--c07039--all-offers",
  "PS": "xf0b3b88a--c07039--container-reverse",
  "ay": "xf0b3b88a--c07039--offer-link",
  "jY": "xf0b3b88a--c07039--popup_content",
};

module.exports = exports;
